import { EntityManager } from "@/components/EntityManager";
import { YES_NO } from "@/constants/options";

export default function Vendors() {
  const columns = [
    { key: "carrier_name", label: "Carrier/Vendor" },
    { key: "region", label: "Region" },
    { key: "primary_contact", label: "Contact" },
    { key: "phone", label: "Phone" },
    { key: "email", label: "Email" },
    { key: "dot_mc_number", label: "DOT/MC" },
    { key: "insurance_expiry", label: "Insurance Exp" },
    { key: "approved_vendor", label: "Approved" },
  ];
  const fields = [
    { label: "Carrier/Vendor Name", field: "carrier_name" },
    { label: "Region", field: "region", placeholder: "e.g. Permian Basin, West Texas" },
    { label: "Primary Contact", field: "primary_contact" },
    { label: "Phone", field: "phone" },
    { label: "Email", field: "email" },
    { label: "DOT/MC Number", field: "dot_mc_number" },
    { label: "Insurance Expiry", field: "insurance_expiry", type: "date" },
    { label: "Approved Vendor", field: "approved_vendor", type: "select", options: YES_NO },
    { label: "Notes", field: "notes", type: "textarea", span: 2 },
  ];
  return <EntityManager collection="vendors" title="Third-Party Vendors" subtitle="Approved carrier network" columns={columns} fields={fields} />;
}
